import React, { useEffect, useState, useCallback } from 'react'
import { useSelector } from 'react-redux'
import Loading from 'custom/assets/loaders/Loading'
import AccountsService from '../../../../services/accounts.service'
import { SIDENAV_KEYS, REQUESTS_KEYS, DIALOG_KEYS } from '../../../../utils/translation-constants'
import { useTranslation } from 'react-i18next'
import LayoutWithOutAccountCard from '../../../../layout/Layout/layout-without-card'
import Pagination from 'react-js-pagination'
import { carouselCurrentItemSelector } from '../../../../selectors'
import AddIcon from 'custom/assets/common-icons/Add.svg'
import { useHistory } from 'react-router-dom'
import { Col, Row } from 'react-bootstrap'
import NumberFormat from 'react-number-format'

function ViewStandingInstruction() {
  const history = useHistory()
  const [stage, setStage] = useState(1)
  const { t } = useTranslation()
  const [noRecords, setNoRecords] = useState(false)
  const [loading, setLoading] = useState(false)
  const [siList, setSiList] = useState([])
  const [currentPage, setCurrentPage] = useState(1)
  const pageLimit = 10
  const currentAccountDetail = useSelector(carouselCurrentItemSelector)
  const [slicedDetailStatementList, setSlicedDetailStatementList] = useState([])

  const sliceDetailedStatement = useCallback(async (currentPageNo, lst) => {
    // useEffect (  () => {
    setCurrentPage(currentPageNo)
    let start = (currentPageNo - 1) * pageLimit
    let end = currentPageNo * pageLimit
    if (lst && lst.length > 0) {
      let x = lst.slice(start, end < lst.length ? end : lst.length)
      setSlicedDetailStatementList(x)
    } else {
    }
  }, [])

  function renderSwitch() {
    switch (stage) {
      case 0:
        return renderLoading()
      // case 1:
      //   return renderSIAccounts()
      default:
        return renderLoading()
    }
  }
  const getSIAccounts = useCallback(async () => {
    try {
      setLoading(true)
      const response = await AccountsService.getSIList(currentAccountDetail.accountNo)
      if (response.status === 200) {
        response.data['siList'].forEach((element) => {
          element.isActive = false
        })
        setSiList(response.data['siList'])
        sliceDetailedStatement(1, response.data['siList'])
        setNoRecords(response.data['siList'].length > 0 ? false : true)
        setLoading(false)
      }
    } catch (err) {
      setLoading(false)
    }
  }, [currentAccountDetail])

  useEffect(() => {
    getSIAccounts()
  }, [])

  function renderLoading() {
    return (
      <div className='mx-4 rounded d-flex justify-content-center align-items-center'>
        <Loading width='50px' height='50px' />
      </div>
    )
  }

  const getSiDetails = useCallback(
    (selected) => {
      try {
        const siListCopy = [...siList]

        if (selected.isActive === true) {
          siListCopy.forEach((element) => {
            element.isActive = false
          })
          setSiList(siListCopy)
          return
        }

        siListCopy.forEach((ele) => {
          if (ele.contractRefNumber === selected.contractRefNumber) {
            ele.isActive = true
          } else {
            ele.isActive = false
          }
        })
        setSiList(siListCopy)
      } catch (err) {}
    },
    [siList],
  )

  return (
    <LayoutWithOutAccountCard breadCumKey='SI' showEmptySpace={true} keyPath={'SI'}>
      <div className='row'>
        <div className='col-7 d-flex'>
          <div className='heading-style' style={{ margin: 0 }}>
            {t(REQUESTS_KEYS.STANDING_INSTRUCTION_KEYS.TITLE)}
          </div>
        </div>
        <div className='col-5 text-right'>
          <button
            style={{ padding: '5px 20px' }}
            onClick={() => history.push('/requests/standing-instruction/create')}
            type='button'
            className='btn detailed-statement-btn'>
            <img className='si-icon' src={AddIcon} />
            <span className='font-weight-600'>
              {t(REQUESTS_KEYS.STANDING_INSTRUCTION_KEYS.CREATE_SI)}
            </span>
          </button>
        </div>
      </div>
      {loading && renderLoading()}
      <div style={{ marginTop: 30 }}>
        {slicedDetailStatementList.map((option, index) => (
          <>
            <div onClick={() => getSiDetails(option)} key={index} className='loan-card '>
              <div className='loan-header'>
                <span>{t(REQUESTS_KEYS.STANDING_INSTRUCTION_KEYS.VIEW_KEYS.REF_NO)}</span>
                <span>{option?.contractRefNumber}</span>
              </div>
              {option.isActive && (
                <div className='loan-details si-card'>
                  <Row>
                    <Col xs={4} sm={4} md={4}>
                      <label>{t(REQUESTS_KEYS.STANDING_INSTRUCTION_KEYS.VIEW_KEYS.REF_NO)}</label>
                      <span>{option?.contractRefNumber || '-'}</span>
                    </Col>
                    <Col xs={4} sm={4} md={4}>
                      <label>
                        {t(REQUESTS_KEYS.STANDING_INSTRUCTION_KEYS.VIEW_KEYS.SOURCE_ACCOUNT)}
                      </label>
                      <span>{option?.srcaccount || '-'}</span>
                    </Col>
                    <Col xs={4} sm={4} md={4}>
                      <label>
                        {t(REQUESTS_KEYS.STANDING_INSTRUCTION_KEYS.VIEW_KEYS.BENEFICIARY_ACCOUNT)}
                      </label>
                      <span>{option?.beneficiaryAccount || '-'}</span>
                    </Col>

                    <Col xs={4} sm={4} md={4}>
                      <label>{t(REQUESTS_KEYS.STANDING_INSTRUCTION_KEYS.VIEW_KEYS.brnCode)}</label>
                      <span>{option?.branchCode || '-'}</span>
                    </Col>

                    <Col xs={4} sm={4} md={4}>
                      <label>{t(REQUESTS_KEYS.DEBIT_CARD_KEYS.CARD_LOAD_KEYS.currency)}</label>
                      <span>{option?.currency || '-'}</span>
                    </Col>

                    <Col xs={4} sm={4} md={4}>
                      <label>{t(SIDENAV_KEYS.SERVICEREQUEST_VIEW_KEYS.AMOUNT)}</label>
                      <NumberFormat
                        value={option?.amount}
                        displayType={'text'}
                        thousandSeparator={true}
                        prefix={''}
                        fixedDecimalScale={true}
                        decimalScale={2}
                        allowEmptyFormatting
                      />
                    </Col>

                    <Col xs={4} sm={4} md={4}>
                      <label>
                        {t(REQUESTS_KEYS.STANDING_INSTRUCTION_KEYS.VIEW_KEYS.START_DATE)}
                      </label>
                      <span>{option?.cyclestartDate || '-'}</span>
                    </Col>

                    <Col xs={4} sm={4} md={4}>
                      <label>
                        {t(REQUESTS_KEYS.STANDING_INSTRUCTION_KEYS.VIEW_KEYS.EXPIRY_DATE)}
                      </label>
                      <span>{option?.expiryDate || '-'}</span>
                    </Col>

                    <Col xs={4} sm={4} md={4}>
                      <label>{t(SIDENAV_KEYS.SERVICEREQUEST_VIEW_KEYS.status)}</label>
                      <span>{option?.status || '-'}</span>
                    </Col>

                    <Col xs={12} sm={12} md={12}>
                      <label>{t(SIDENAV_KEYS.SERVICEREQUEST_VIEW_KEYS.NARRATION)}</label>
                      <span>{option?.remarks || '-'}</span>
                    </Col>
                  </Row>
                </div>
              )}
            </div>
          </>
        ))}
      </div>
      {noRecords && (
        <div className='no-data-found'>
          {t(REQUESTS_KEYS.STANDING_INSTRUCTION_KEYS.VIEW_KEYS.NO_SI)}{' '}
        </div>
      )}
      <br />
      {siList.length > 0 && siList.length > 10 ? (
        <div className='d-flex justify-content-center mb-5 mt-2'>
          {loading ? null : (
            <Pagination
              activePage={currentPage}
              itemsCountPerPage={10}
              totalItemsCount={siList.length}
              pageRangeDisplayed={5}
              itemClass='page-item'
              linkClass='page-link'
              onChange={(page) => sliceDetailedStatement(page, siList)}
            />
          )}
        </div>
      ) : null}
    </LayoutWithOutAccountCard>
  )
}

export default ViewStandingInstruction
